import React from "react";
import "@fortawesome/fontawesome-free/css/all.css";

export const Features = (props) => {
  return (
    <div id="technologies" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>TECHNOLOGIES</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
                return (
                  <div key={`${d.title}-${i}`} className="col-xs-6 col-md-4">
                    {" "}
                    <i className={d.icon}></i>
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                  </div>
                );
              })
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
